import { FC, ReactNode } from 'react';
import style from './index.module.css';

export const Badge: FC<{
  children?: ReactNode,
  color?: 'green' | 'purple' | 'yellow'
}> = ({
  children,
  color = 'green'
}) => {
  return (
    <div className={style.root}>
      <i 
        className={style.item}
        data-color={color}
      >{children}</i>
    </div>
  )
}